import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Observable, of } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { Estimativa } from 'src/app/models/estimativa.model';
import { Cliente } from 'src/app/models/cliente.model';
import { EstimativaService } from 'src/app/services/estimativa.service';
import { ClienteService } from 'src/app/services/cliente.service';
import { StatusService } from 'src/app/services/status.service';
import { ToastrComponent } from '../util/toastr/toastr.component';
import { Misc } from '../util/misc';
import { UtilService } from 'src/app/services/util.service';
import { EstimativaStatusConstants, PerfilConstants, TipoEstimativaConstants } from 'src/app/models/constants/constants';
import { MatDialog } from '@angular/material/dialog';
import { EstimativaNovaComponent } from '../estimativa/estimativa-nova.component';
import { EstimativaDuplicarComponent } from '../estimativa/estimativa-duplicar.component';
import { FilterEstimativa } from 'src/app/models/filter/filter-estimativa';
import { PriceEstimativaExcluirDialogComponent } from './price-estimativa-excluir-dialog/price-estimativa-excluir-dialog.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-price-simulacao-list',
  templateUrl: './price-simulacao-list.component.html',
  styleUrls: ['./price-simulacao-list.component.scss']
})
export class PriceSimulacaoComponent implements OnInit {
  formPesquisa: FormGroup;
  filtroCliente: FormControl = new FormControl('');
  clientes: Cliente[] = [];
  clientesFiltrada: Observable<Cliente[]> = of([]);

  statusId = Array<number>(0);

  estimativas: Estimativa[] = [];
  status: any[] = [];
  dataSource = new MatTableDataSource<Estimativa>();
  displayedColumns: string[] = ['deletar', 'cliente', 'crm', 'projeto', 'nome', 'tipo', 'data', 'status', 'acao'];

  loading = true;
  isAdmin = false;
  isSolution = false;
  delivery = false;
  userId: number;

  titulo = 'Consulta Simulações';
  crm = '';

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  projetoId: 0;

  constructor(
    private fb: FormBuilder,
    private estimativaService: EstimativaService,
    private clienteService: ClienteService,
    private statusService: StatusService,
    private toastr: ToastrComponent,
    private misc: Misc,
    private utilService: UtilService,
    private dialog: MatDialog,
    private activatedRouter: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    const user = JSON.parse(localStorage.getItem('currentUserPricingWeb'));
    this.userId = user.id;
    const perfilId = user.perfil[0]?.id;

    this.isAdmin = perfilId === PerfilConstants.ID_PERFIL_ADMINISTRADOR;
    this.delivery = perfilId === PerfilConstants.ID_PERFIL_DELIVERY;
    this.isSolution = perfilId === PerfilConstants.ID_PERFIL_SOLUTION;

    this.projetoId = this.activatedRouter.snapshot.params.projetoId || 0;

    if (this.activatedRouter.snapshot.params.statusId && this.activatedRouter.snapshot.params.statusId !== '0') {
      this.statusId = this.activatedRouter.snapshot.params.statusId.split(',').map(Number);
    }

    this.createForm();

    this.statusService.getAll().subscribe(status => {
      this.status = status.items;
    });

    this.createForm();
    this.carregarClientes();
    this.carregarStatus();
    this.pesquisar(false, this.formPesquisa.value.minhasEstimativas);
  }

  createForm(): void {
    this.formPesquisa = this.fb.group({
      cliente: [null],
      projeto: [null],
      estimativa: [null],
      statusId: [[]],
      minhasEstimativas: [null]
    });
  }

  carregarClientes(): void {
    if (this.isAdmin) {
      this.clienteService.GetAllIncludeNotActive().subscribe((result) => {
        this.clientes = result?.items ?? [];
        this.clientesFiltrada = this.filtroCliente.valueChanges.pipe(
          startWith(''),
          map(value => this._filterClientes(value))
        );
      });
    } else {
      this.clienteService.getAllByUnidade(this.utilService.getUnidadeId()).subscribe((result) => {
        this.clientes = Array.isArray(result) ? result : [];
        this.clientesFiltrada = this.filtroCliente.valueChanges.pipe(
          startWith(''),
          map(value => this._filterClientes(value))
        );
      });
    }
  }

  carregarStatus(): void {
    this.statusService.getAll().subscribe(result => {
      this.status = result.items;
    });
  }

  pesquisar(carregarClientes: boolean, minhasEstimativasIsChecked: boolean = false): void {
    this.formPesquisa.controls['minhasEstimativas'].setValue(minhasEstimativasIsChecked ?? false);

    this.loading = true;

    const statusId = this.formPesquisa.value.statusId ?? [];

    const estimativa = {
      projetoId: this.projetoId,
      projeto: this.formPesquisa.value.projeto,
      nome: this.formPesquisa.value.estimativa,
      statusId: Array.isArray(statusId) ? statusId : [statusId],
      usuarioId: this.utilService.getUserId(),
      clienteId: this.formPesquisa.value.cliente ? this.formPesquisa.value.cliente.id : 0,
      crmId: this.formPesquisa.value.projeto
    } as FilterEstimativa;

    this.estimativaService.pesquisarSimulacao(estimativa, !!minhasEstimativasIsChecked).subscribe(
      estimativas => {
        this.loading = false;

        // this.estimativas = this.isAdmin
        //   ? estimativas.items.filter(e => e.estimativaTipoId === TipoEstimativaConstants.ID_TIPO_ESTIMATIVA_DELIVERY)
        //   : estimativas.items.filter(e =>
        //     e.estimativaTipoId === TipoEstimativaConstants.ID_TIPO_ESTIMATIVA_DELIVERY &&
        //     e.usuarioId === this.userId
        //   );

        this.estimativas = estimativas.items.filter(e => {
          if (e.estimativaTipoId !== TipoEstimativaConstants.ID_TIPO_ESTIMATIVA_DELIVERY) {
            return false;
          }

          if (this.isAdmin) {
            return true;
          }

          return e.usuarioId === this.userId;
        })

        this.dataSource = new MatTableDataSource<Estimativa>(this.estimativas);

        if (this.dataSource.filteredData.length === 0) {
          this.toastr.mostrarMensagem('aviso', 'Aviso', 'Nenhuma estimativa encontrada.');
        }

        this.dataSource.paginator = this.paginator;
      },
      error => {
        this.loading = false;
        this.misc.processError(error, 'Erro ao buscar estimativas.');
      }
    );
  }

  verificaCliente(event: any) {
    setTimeout(() => {
      if (!this.filtroCliente.value?.id) {
        this.filtroCliente.reset();
        this.formPesquisa.patchValue({ cliente: null });
        this.pesquisar(false, this.formPesquisa.value.minhasEstimativas);
      }
    }, 500);
  }

  carregaCliente(cliente: Cliente): void {
    this.formPesquisa.patchValue({ cliente });
    this.pesquisar(false, this.formPesquisa.value.minhasEstimativas);
  }

  voltar(): void {
    this.crm = '';
    this.titulo = 'Simulações Delivery';
    this.pesquisar(false, this.formPesquisa.value.minhasEstimativas);
  }

  recuperaNomeStatus() {
    let nomeStatus = '';

    const selected = this.formPesquisa?.value?.statusId;
    if (this.status.length > 0 && selected?.length > 0) {
      const status = this.status.find(s => s.id === selected[0]);
      nomeStatus = status ? status.nome : '';
    }

    return nomeStatus;
  }

  descartarEstimativa(estimativa: Estimativa): void {
    const atualizada = { ...estimativa, statusId: EstimativaStatusConstants.ID_ESTIMATIVA_DESCARTADA };
    this.loading = true;

    this.estimativaService.update(atualizada).subscribe({
      next: () => {
        this.toastr.mostrarMensagem('sucesso', 'Sucesso', 'Estimativa descartada com sucesso.');
        this.pesquisar(false, this.formPesquisa.value.minhasEstimativas);
      },
      error: (error) => {
        this.misc.processError(error, 'Erro ao descartar estimativa.');
      }
    }).add(() => this.loading = false);
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(EstimativaNovaComponent, {
      width: '600px',
      minWidth: '500px',
      panelClass: 'default-dialog-container'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.pesquisar(false, this.formPesquisa.value.minhasEstimativas);
      }
    });
  }

  openDuplicar(estimativa: Estimativa): void {
    const dialogRef = this.dialog.open(EstimativaDuplicarComponent, {
      width: '600px',
      data: {
        usuarioId: this.userId,
        estimtvId: estimativa.id,
        element: estimativa,
        edit: true
      },
      panelClass: 'default-dialog-container',
    });

    dialogRef.afterClosed().subscribe(() => {
      this.pesquisar(false, this.formPesquisa.value.minhasEstimativas);
    });
  }

  openDialogExcluir(element: any): void {
    const dialogRef = this.dialog.open(PriceEstimativaExcluirDialogComponent, {
      width: '500px',
      panelClass: 'default-dialog-container',
      data: element
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == true) {
        this.pesquisar(false, this.formPesquisa.value.minhasEstimativas);
      }
    });
  }

  mostrarMinhasEstimativas(event: any): void {
    const somenteMinhas = event.checked === true;
    this.formPesquisa.controls['minhasEstimativas'].setValue(somenteMinhas)
    this.pesquisar(false, somenteMinhas);
  }

  disableDuplicationForDeliveryProfile(estimativa: Estimativa): boolean {

    if (this.delivery == true && estimativa.estimativaTipoId == TipoEstimativaConstants.ID_TIPO_ESTIMATIVA_BODYSHOP) {
      return true;
    }
    if (this.delivery == true && estimativa.estimativaTipoId == TipoEstimativaConstants.ID_TIPO_ESTIMATIVA_DELIVERY) {
      return true;
    }

    if (this.isAdmin == true && estimativa.estimativaTipoId == TipoEstimativaConstants.ID_TIPO_ESTIMATIVA_DELIVERY) {
      return true;
    }
  }

  private _filterClientes(value: any): Cliente[] {
    if (typeof value === 'string') {
      const filterValue = value.toLowerCase();
      return this.clientes.filter(option => option.nome.toLowerCase().includes(filterValue));
    }
    return this.clientes
  }

  displayFn(cliente: Cliente): string {
    return cliente && cliente.nome ? cliente.nome : '';
  }

  onSubmit(evt: Event) {
    evt.preventDefault();
  }
}
